import styled from 'styled-components';

import {
  Card,
  Dimmer,
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

import { Header as HeaderLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled(Dimmer)`
`;

const Dialog = styled(Card)`
  &&& {
    padding: 30px;
    width: 600px;
    height: 100%;
    background-color: ${({ theme }) => theme.background};
    border-radius: 1px;
  }
`;

const Header = styled(HeaderLayoutComponent)`
  text-align: justify;
  margin-bottom: 0px;
`;

const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ContainerTitle = styled.div``;

const ContainerLabel = styled(TextLayoutComponent)`
  display: flex;
  flex-wrap: wrap;
`;

const LabelIndirect = styled(TextLayoutComponent).attrs(() => ({ fontSize: '12px' }))`
  display: flex;
  font-weight: 500;
`;

const Square = styled.div`
  height:12px;
  width:12px;
  background: ${({ resultType }) => resultType};
  margin-right: 10px;
`;

const ContainerSection = styled.div`
  display: flex;
  margin-top: 22px;
  color: ${({ theme }) => theme.color.text};
`;

const Dropdown = styled(SemanticDropdown)`
  margin-right: 18px;
`;

const ContainerDropdown = styled.div`
  display: flex;
  align-items: center;;
`;

const ContainerSquare = styled.div`
  display: flex;
  align-items: center;
`;

export {
  Container,
  ContainerHeader,
  Dialog,
  Header,
  ContainerTitle,
  ContainerLabel,
  Dropdown,
  ContainerSection,
  Square,
  ContainerSquare,
  LabelIndirect,
  ContainerDropdown,
};
